interface Domain {
    min: number,
    max: number,
}

export interface Bounds {
    temp: Domain,
    window: Domain,
    curtains: Domain,
    mecanical_ventilation: Domain,
    artificial_light: Domain,
    electric_equipement: Domain,
    dressing: Domain,
    cost: Domain,
    ges: Domain,
    energy: Domain,
    energie_tot: Domain,
    air_quality: Domain,
    visual_comfort: Domain,
    thermal_comfort: Domain,
    electricity: Domain,
    chauffage: Domain,
    climatisation: Domain,
    clim_on_off: Domain,
    app_elect: Domain
}

export const DEFAULT_BOUNDS: Bounds = {
    temp: {
        min: 0,
        max: 0
    },
    artificial_light: {
        min: 0,
        max: 0
    },
    curtains: {
        min: 0,
        max: 0
    },
    window: {
        min: 0,
        max: 0
    },
    electric_equipement: {
        min: 0,
        max: 0
    },
    dressing: {
        min: 0,
        max: 0
    },
    mecanical_ventilation: {
        min: 0,
        max: 0
    },
    cost: {
        min: 0,
        max: 5000
    },
    energy: {
        "min": 0,
        "max": 8000
    },
    energie_tot: {
        "min": 0,
        "max": 8000
    },
    ges: {
        "min": 0,
        "max": 5000
    },
    air_quality: {
        min: -5,
        max: 5
    },
    visual_comfort: {
        min: -5,
        max: 5
    },
    thermal_comfort: {
        min: -5,
        max: 5
    },
    chauffage: {
        min: 0,
        max: 10
    },
    climatisation: {
        min: 0,
        max: 10
    },
    electricity: {
        min: 0,
        max: 10
    },
    clim_on_off:{
        min:0,
        max:1
    },
    app_elect: {
        min: 0,
        max: 10
    }

}